<template>
  <div class="jr-mx-15">
    <div class="jr-text-left">
      <div class="jr-font-base jr-text-sm">
        <p class="jr-whitespace-nowrap">選択したエリア来訪者の来訪同日中の行動をヒートマップで表示しています。</p>
      </div>
    </div>
  </div>
</template>
